export default __webpack_public_path__ + "static/media/FriendlyEnv.07fadaf6.jpg";